module.exports = __webpack_public_path__ + "img/sci-fund-logo.c3eb593a.png";